

export function toggleConnectOdp() {
    const cookieName = "connect-login";
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());



    //if this is true use connect login
    return cookies.some(cookie => cookie.startsWith(`${cookieName}=`));
}